export const stationConfigurationsTypes = {
    SET_STATION_CONFIGURATIONS_FILTERS: 'SET_STATION_CONFIGURATIONS_FILTERS',
    CLEAR_STATION_CONFIGURATIONS: 'CLEAR_STATION_CONFIGURATIONS',
    SET_COMPANY_DATA: 'SET_COMPANY_DATA',
    RESTORE_INITIAL: 'RESTORE_INITIAL',
}